import { defineComponent as B, computed as d, openBlock as s, createBlock as $, resolveDynamicComponent as H, normalizeStyle as M, normalizeClass as m, withCtx as D, createElementBlock as l, createElementVNode as T, toDisplayString as b, createCommentVNode as h, renderSlot as E, createVNode as F } from "vue";
import N from "./index62.js";
import { useTheme as V } from "@template/theme";
const j = {
  key: 0,
  class: "flex flex-col items-center justify-center"
}, K = {
  key: 0,
  class: "btn-sub-text font-semibold"
}, P = {
  key: 1,
  class: "button-skeleton"
}, Q = /* @__PURE__ */ B({
  __name: "TempBaseButton",
  props: {
    variant: { default: "light" },
    color: { default: "red" },
    size: { default: "lg" },
    label: { default: "" },
    subLabel: {},
    fullWidth: { type: Boolean, default: !1 },
    customClass: {},
    isLoading: { type: Boolean }
  },
  emits: ["click"],
  setup(f, { emit: g }) {
    const { isDark: p } = V(), e = f;
    e.variant;
    const o = g, c = ["red", "blue"], x = d(() => e.label || e.subLabel), y = d(() => {
      const t = [
        "inline-flex items-center justify-center gap-2.5",
        "transition-all duration-200",
        "select-none",
        "focus:outline-none",
        e.fullWidth ? "w-full" : "",
        p.value ? e.variant === "light" ? "btn-variant-contained" : `btn-variant-${e.variant}` : `btn-variant-${e.variant}`,
        `btn-size-${e.size}`
      ];
      return c.includes(e.color) && t.push(`btn-color-${e.color}`), e.customClass && t.push(e.customClass), t;
    });
    function k(t) {
      o("click", t);
    }
    function z(t) {
      (t.key === " " || t.key === "Enter") && (t.preventDefault(), o("click", t));
    }
    const v = () => {
      const t = e.label?.length || 0, n = e.subLabel?.length || 0, r = () => {
        switch (e.size) {
          case "md":
            return 14;
          // btn-size-md font-size: 14px
          case "sm":
            return 13;
          // btn-size-sm font-size: 13px
          case "mini":
            return 12;
          // btn-size-mini font-size: 12px
          default:
            return 16;
        }
      }, a = () => {
        switch (e.size) {
          case "md":
            return { x: 20, y: 6 };
          // padding: 6px 20px
          case "sm":
            return { x: 12, y: 10 };
          // padding: 10px 12px
          case "mini":
            return { x: 10, y: 2 };
          // padding: 2px 8px
          default:
            return { x: 16, y: 12 };
        }
      }, u = r(), _ = a(), C = u * 0.6;
      let i = t * C;
      if (n > 0) {
        const W = (e.size === "mini" ? 10 : e.size === "sm" ? 12 : 14) * 0.6;
        i = Math.max(i, n * W);
      }
      const S = i + 0 + _.x * 2, w = e.size === "md" ? 60 : e.size === "sm" ? 50 : e.size === "mini" ? 40 : 80;
      return Math.max(w, Math.min(400, S)) + "px";
    }, L = () => {
      const n = (() => {
        switch (e.size) {
          case "md":
            return 40;
          // height: 40px
          case "sm":
            return 36;
          // height: 36px
          case "mini":
            return 20;
          // height: 20px
          default:
            return 48;
        }
      })();
      if (!!e.subLabel) {
        const a = e.size === "mini" ? 14 : e.size === "sm" ? 16 : 18;
        return n + a + 2 + "px";
      }
      return n + "px";
    };
    return (t, n) => e.isLoading ? (s(), l("div", P, [
      F(N, {
        width: v(),
        height: L(),
        variant: "rectangular",
        class: "button-skeleton-element"
      }, null, 8, ["width", "height"])
    ])) : (s(), $(H("button"), {
      key: 0,
      role: "button",
      type: "button",
      class: m([...y.value, "focus-ring"]),
      style: M(
        c.includes(e.color) ? {} : { "--button-custom-color": e.color }
      ),
      "aria-label": e.label,
      onClick: k,
      onKeydown: z
    }, {
      default: D(() => [
        x.value ? (s(), l("div", j, [
          T("span", {
            class: m(["font-medium", e.subLabel ? "btn-main-label" : "btn-label"])
          }, b(e.label), 3),
          e.subLabel ? (s(), l("span", K, b(e.subLabel), 1)) : h("", !0)
        ])) : h("", !0),
        E(t.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["class", "style", "aria-label"]));
  }
});
export {
  Q as default
};
